import React, { useState } from "react";
import styles from "./Table.module.sass";
import cn from "classnames";
import Checkbox from "../../../components/Checkbox";
import Row from "./Row";

const Table = ({
  className,
  items = [],
  onProspectSelect,
  onSelectionChange
}) => {
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [chooseAll, setСhooseAll] = useState(false);
  const [activeId, setActiveId] = useState(null);

  const handleChange = (id) => {
    let newSelectedFilters;
    if (selectedFilters.includes(id)) {
      newSelectedFilters = selectedFilters.filter((x) => x !== id);
      setSelectedFilters(newSelectedFilters);
    } else {
      newSelectedFilters = [...selectedFilters, id];
      setSelectedFilters(newSelectedFilters);
    }
    // Notifier le composant parent des changements dans la sélection
    if (onSelectionChange) {
      onSelectionChange(newSelectedFilters);
    }
  };


  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={cn(styles.table)}>
        <div className={styles.row}>
          <div className={styles.col}>
            <Checkbox
              className={styles.checkbox}
              checked={chooseAll}
              onChange={() => {
                const newValue = !chooseAll;
                setСhooseAll(newValue);
                
                // Si on coche 'tout sélectionner', on sélectionne tous les prospects
                // Sinon, on vide la sélection
                const newSelectedFilters = newValue ? items.map(item => item.id) : [];
                setSelectedFilters(newSelectedFilters);
                
                // Notifier le composant parent
                if (onSelectionChange) {
                  onSelectionChange(newSelectedFilters);
                }
              }}
            />
          </div>
          <div className={styles.col}>Nom Prénom</div>
          <div className={styles.col}>Coordonnées</div>
          <div className={styles.col}>Assigné à</div>
          <div className={styles.col}>Dernier contact</div>
          <div className={styles.col}>Statut</div>
        </div>
        {items.map((x, index) => (
          <Row
            item={x}
            key={index}
            activeId={activeId}
            setActiveId={setActiveId}
            value={selectedFilters.includes(x.id)}
            onChange={() => handleChange(x.id)}
          />
        ))}
      </div>

    


    </div>
  );
};

export default Table;
